module.exports = __webpack_public_path__ + "img/main.92988130.jpg";